import { ApplicationRef, ChangeDetectorRef, inject, Injectable } from '@angular/core';

/*
 * This code is from @ngrx/component, but it is not exported
 * https://github.com/ngrx/platform/blob/master/modules/component/src/core/tick-scheduler.ts
 *
 * this is a workaround for markDirty function used in rt-input
 */

@Injectable({ providedIn: 'root' })
export class AnimationFrameTickScheduler {
  private isScheduled = false;

  constructor(private readonly appRef: ApplicationRef) {}

  public schedule(): void {
    if (!this.isScheduled) {
      this.isScheduled = true;
      requestAnimationFrame(() => {
        this.appRef.tick();
        this.isScheduled = false;
      });
    }
  }
}

@Injectable()
export class RenderScheduler {
  constructor(
    private cdRef: ChangeDetectorRef,
    private tickScheduler: AnimationFrameTickScheduler,
  ) {}

  public schedule(): void {
    // eslint-disable-next-line ban/ban
    this.cdRef.markForCheck();
    this.tickScheduler.schedule();
  }
}

export function injectRenderScheduler(): RenderScheduler {
  return new RenderScheduler(inject(ChangeDetectorRef), inject(AnimationFrameTickScheduler));
}
